<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{ $route.meta.title }}
        </div>
        <push-write-component :pushType="'pushCreate'" :pushKey="pushKey"></push-write-component>
        <div class="pa15 text-center btn_wrap">
          <el-button type="save" @click="save()">저장</el-button>
          <el-button type="cancel" @click="backEvent()">목록</el-button>
        </div>
      </div>
      <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
    <push-type-select-modal></push-type-select-modal>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import PushWriteComponent from "@/components/push/PushWriteComponent";
import PushTypeSelectModal from "@/components/modal/PushTypeSelectModal.vue";

export default {
  name: "PushCreate",
  mixins: [],
  components: {PushTypeSelectModal, PushWriteComponent,},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      pushKey: this.$route.params.idx,
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    save() {
      EventBus.$emit('writePush');
    },
    backEvent() {
      this.$router.back()
    },
  },
  watch: {},
}
</script>

<style lang="scss">
</style>